import { GlobalStatus, SaleStatusEnum, SoStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { Invoice } from "./invoice.entity";

@Entity('invoice_items')
export class InvoiceItems {

  @PrimaryGeneratedColumn("increment", { name: 'invoice_item_id' })
  invoiceItemId: number;

  @Column("int", {
    nullable: false,
    name: "sale_order_item_id"
  })
  saleOrderId: number;

  @Column("int", {
    nullable: false,
    name: "item_id"
  })
  itemId: number;
  @Column("int", {
    nullable: false,
    name: "min_grade_id"
  })
  minGrade: number;
  @Column("int", {
    nullable: false,
    name: "max_grade_id"
  })
  maxGrade: number;
  @Column("int", {
    nullable: false,
    name: "food_type_id"
  })
  foodTypeId: number;
  @Column("int", {
    nullable: true,
    name: "value_addition_one_id"
  })
  valueAdditionOneId: number;
  @Column("int", {
    nullable: true,
    name: "value_addition_two_id"
  })
  valueAdditionTwoId: number;
  @Column("int", {
    nullable: true,
    name: "value_addition_three_id"
  })
  valueAdditionThreeId: number;
  @Column("int", {
    nullable: true,
    name: "value_addition_four_id"
  })
  valueAdditionFourId: number;
  @Column("int", {
    nullable: true,
    name: "value_addition_five_id"
  })
  valueAdditionFiveId: number;

  @Column("int", {
    nullable: false,
    name: "varient_id"
  })
  varientId: number;

  

  @Column({
    type: 'decimal', precision: 10, scale: 2,
    nullable: false,
    name: "net_amount"
  })
  netAmount: number;

  @Column({
    type: 'decimal', precision: 10, scale: 2,
    nullable: false,
    name: "unitPrice"
  })
  unitPrice: number;


  @Column("int", {
    nullable: false,
    name: "pouches"
  })
  pouches: number;

 

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    name: "shrimp_weight" 
  })
  shrimpWeight: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    name: "invoiced_qty" 
  })
  invoicedQty: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    name: "pouch_weight"
  })
  pouchWeight: number;

  @Column("int", {
    nullable: false,
    name: "cases"
  })
  cases: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    name: "case_weight"
  })
  caseWeight: number;

  

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable: false,
    name: "net_weight"
  })
  netWeight: number;

  @Column("int", {
    nullable: false,
    name: "uom_id"
  })
  uomId: number;


  @Column("varchar", {
    nullable: false,
    length: 20,
    name: "style_weighment"
  })
  styleWeighment: string;

 

  

 

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type => Invoice, invoice => invoice.invoiceItemsInfo, { nullable: false, })
  @JoinColumn({ name: "invoice_id" })
  invoiceInfo: Invoice;
  
}
